var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('CoverPage'),_c('AboutUs'),_c('div',{staticClass:"abtus-bg"},[_c('Achievements')],1),_c('Team'),_c('LegalDocu'),_c('div',{staticClass:"w-full"},[_c('Counters')],1),_c('div',{staticClass:"bge3ceff-opa rounded-t-5555"},[_c('DownloadApp'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }